import type { Translations } from "../keys.js";

export const fi = {
  eyebrow: "IBKR-tiliote",
  title: "Tuotto-riskisuhteen raportti",
  uploadMark: "Flex XML",
  uploadTitle: "Pudota tai valitse IBKR XML",
  uploadBody: "Nimi, tili ja osoite peitetään paikallisesti.",
  nfaDisclaimer: "Vain opiskeluun ja kaupankäynnin läpikäyntiin. Ei sijoitusneuvo.",
  chooseFile: "Valitse tiedosto",
  account: "Tili",
  name: "Nimi",
  neutralName: "momo",
  period: "Jakso",
  baseCurrency: "Perusvaluutta",
  closed: "suljettua",
  executions: "toteutusta",
  netRealized: "Nettorealisoitu",
  winRate: "Voittoprosentti",
  payoffRatio: "Tuotto-riskisuhde",
  expectancy: "Odotusarvo",
  executionRecords: "Toteutukset",
  canceledOrders: "Perutut toimeksiannot",
  medianHoldingDays: "Mediaanipitoaika",
  commissionDrag: "Palkkiot",
  closedTradeSum: "Suljettujen kauppojen summa",
  grossProfitLoss: "Bruttovoitto / bruttotappio",
  averageWinLoss: "Keskivoitto / keskitappio",
  perClosedTrade: "Per suljettu kauppa",
  flexTradeRecords: "Flex XML:n Trade-rivit",
  flexCanceledRecords: "Flex XML:n perutut Order-rivit",
  noCanceledRecords: "Tässä XML:ssä ei ole peruttuja toimeksiantoja",
  holdingReview: "Holding",
  holdingReviewTitle: "Pitoajan ja suhteen analyysi",
  holdingReviewHint: "Yhdistää avaukset ja sulut sekä vertaa PF:ää, suhdetta ja voittoprosenttia pitoajan mukaan.",
  holdingPeriod: "Pitoaika",
  holdingIntraday: "Päivänsisäinen",
  holdingSwing: "1-7 päivää",
  holdingPosition: "8-30 päivää",
  holdingLongTerm: "30+ päivää",
  directionReview: "Direction",
  directionReviewTitle: "Long / short -analyysi",
  directionReviewHint: "Jakaa suljetut kaupat strategia-altistuksen mukaan ja näyttää vahvemman puolen.",
  longPosition: "Long",
  shortPosition: "Short",
  neutralPosition: "Neutral",
  equityCurve: "Pääomakäyrä",
  dailyRealized: "Päivittäinen realisoitu P/L",
  payoff: "Tuotto-riskisuhde",
  winLossDistribution: "Voittojen ja tappioiden jakauma",
  periodPerformance: "Jakson tulos",
  periodHint: "Vihreät pylväät ovat voittoa, punaiset tappiota. PF ja suhde ovat alla taulukossa.",
  weekly: "Viikko",
  monthly: "Kuukausi",
  periodColumn: "Jakso",
  monthColumn: "Kuukausi",
  realized: "Realisoitu",
  profitFactor: "Profit Factor",
  pf: "PF",
  payoffShort: "Suhde",
  trades: "Kaupat",
  assetBreakdown: "Omaisuuslajit",
  assetBreakdownTitle: "Osake- / optiotilastot",
  asset: "Omaisuuslaji",
  medianPnl: "Mediaani P/L",
  average: "Keskiarvo",
  optionReview: "Optiot",
  optionReviewTitle: "Optiot kohde-etuuden mukaan",
  underlying: "Kohde-etuus",
  date: "Päivä",
  dateCount: "Päivät",
  daysShort: "pv",
  hoursShort: "h",
  minutesShort: "min",
  weakestSession: "Heikoin sessio",
  intradaySessionNoData: "Ei sulkuja normaalissa sessiossa",
  intradaySessionTitle: "Avaus / keskipäivä / sulku -voittoprosentti",
  intradaySessionHint: "Ryhmittelee sulut session mukaan ja vertaa toteutunutta tulosta, mediaani P/L:ää, keskiarvoa, PF:ää, suhdetta ja voittoprosenttia.",
  weekdayReviewTitle: "Kaupankäynnin tulos viikonpäivittäin",
  weekdayReviewHint: "Vertaa normaalin session sulkuja ja automaattisia erääntymisiä viikonpäivittäin ja näyttää parhaan sekä heikoimman tuotto-riskisuhteen.",
  weekday: "Viikonpäivä",
  weekdaySunday: "Sunnuntai",
  weekdayMonday: "Maanantai",
  weekdayTuesday: "Tiistai",
  weekdayWednesday: "Keskiviikko",
  weekdayThursday: "Torstai",
  weekdayFriday: "Perjantai",
  weekdaySaturday: "Lauantai",
  bestDay: "Paras",
  worstDay: "Heikoin",
  session: "Sessio",
  sessionMorning: "Avaus",
  sessionMidday: "Keskipäivä",
  sessionLate: "Sulku",
  autoExpiry: "Automaattinen erääntyminen",
  optionLifecycle: "Erääntyminen / selvitys",
  optionLifecycleRegularClose: "Normaali sulkeminen",
  optionLifecycleEp: "Erääntynyt",
  optionLifecycleEx: "Toteutus",
  optionLifecycleA: "Määräys",
  optionLifecycleCD: "Käteisselvitys",
  optionLifecycleAEx: "Automaattinen toteutus",
  optionLifecycleMEx: "Manuaalinen toteutus",
  optionLifecycleGEA: "Kuittaus: erääntyminen / määräys",
  discipline: "Kurinalaisuus",
  disciplineRisk: "Kurinalaisuuden riski",
  largeLossAlert: "Suuren tappion varoitus",
  largeLossDiscipline: "Pysähdy ensin. Suojaa kurinalaisuus.",
  largeLossRule: "Tämän päivän kokonaistappio ylittää nykyisen riskirajan. Älä kasvata kokoa tappion takaisin voittamiseksi ennen kuin olet tarkistanut suunnitellun stopin, päivän enimmäistappion ja taukosäännön.",
  worstLossDay: "Suurin päivätappio",
  symbols: "Symbolit",
  symbolPerformance: "Symbolien ranking",
  page: "Sivu",
  previousPage: "Edellinen sivu",
  nextPage: "Seuraava sivu",
  offlineCoach: "Offline-valmentaja",
  offlineAdvice: "Offline-neuvot",
  bestLoserWins: "Paras häviäjä voittaa",
  theme: "Teema",
  language: "Kieli",
  dark: "Tumma",
  light: "Vaalea",
  stock: "Osakkeet",
  option: "Optiot",
  other: "Muut",
  cash: "Käteinen",
  future: "Futuuri",
  unknown: "Tuntematon",
  winBucketSmall: "Pieni voitto",
  winBucketMedium: "Keskivoitto",
  winBucketLarge: "Suuri voitto",
  lossBucketSmall: "Pieni tappio",
  lossBucketMedium: "Keskitappio",
  lossBucketLarge: "Suuri tappio",
  chartEmpty: "Ei suljettuja kauppoja kaavioon",
  dailyChartLegend: "pylväät: päivä, viiva: kumulatiivinen",
  periodChartLegend: "PF, viite 1.00, yläraja",
  importFailed: "Tuonti epäonnistui",
  profitStatus: "Voitto",
  lossStatus: "Tappio",
  flatStatus: "Tasainen",
  costStatus: "Kulu",
  toggleDetails: "Näytä tiedot",
  "error.invalid_flex_xml": "Lataa IBKR Flex XML -tiedosto.",
  "advice.profit_factor_below_one.title": "PF on alle 1",
  "advice.profit_factor_below_one.body": "Nykyinen PF on {profitFactor}. Kokonaisvoitot eivät vielä kata kokonaistappioita. Vähennä ensin suuria tappioita, erääntymistappioita ja hallitsemattomia lisäyksiä ennen kauppamäärän kasvattamista.",
  "advice.profit_factor_thin_edge.title": "PF:ssä on ohut turvamarginaali",
  "advice.profit_factor_thin_edge.body": "Nykyinen PF on {profitFactor}. Tilanne on kaupattava, mutta yksi tai kaksi hallitsematonta tappiota voi pyyhkiä koko jakson. Määritä ensin päivän enimmäistappio, viimeinen poistumisaika ja taukosäännöt.",
  "advice.profit_factor_healthy.title": "PF-rakenne näyttää terveemmältä",
  "advice.profit_factor_healthy.body": "Nykyinen PF on {profitFactor}. Älä kasvata frekvenssiä sokkona. Etsi toistettavat symbolit, sessiot ja setupit, ja säilytä vain laadukkaammat kaupat.",
  "advice.winrate_and_payoff_weak.title": "Voittoprosentti ja tuotto-riskisuhde eivät voi olla yhtä aikaa heikkoja",
  "advice.winrate_and_payoff_weak.body": "Voittoprosentti on {winRate} ja tuotto-riskisuhde {payoffRatio}. Osumatarkkuus tai keskimääräinen tuotto eivät vielä kompensoi riittävästi. Varmista tavoitetila ja stopin etäisyys ennen sisääntuloa.",
  "advice.high_winrate_weak_payoff.title": "Voittoprosentti paikkaa heikkoa tuotto-riskisuhdetta",
  "advice.high_winrate_weak_payoff.body": "Voittoprosentti on {winRate}, mutta tuotto-riskisuhde on {payoffRatio}. Yksi huono kauppa voi kuluttaa useita hyviä. Kyse on usein poistumisesta ja riskin määrittelystä, ei vain suunnasta.",
  "advice.overtrade_loss_days.title": "Tappiopäivissä näkyy kiihtymistä",
  "advice.overtrade_loss_days.body": "{days} päivänä oli sekä paljon kauppoja että negatiivinen PnL. Käy ensimmäisen tappion jälkeiset kaupat erikseen läpi: olivatko ne vielä suunnitelmaa vai yrityksiä voittaa tappio takaisin?",
  "advice.auto_expiry_losses.title": "Automaattiset erääntymistappiot eivät ole kohinaa",
  "advice.auto_expiry_losses.body": "{count} automaattista erääntymistappiota sisällytettiin. Nollaan erääntyminen pitää käsitellä hallittavana riskinä, ei päivän lopun vahinkona. Kirjoita viimeinen hyväksyttävä poistumisaika ylös.",
  "advice.good_loser_base.title": "Hyvä häviäjä suojaa seuraavaa kauppaa",
  "advice.good_loser_base.body": "Keskivoitto on {avgWin} ja keskitappio {avgLoss}. Suunnitelman sisäiset tappiot ovat kuluja; suunnitelman ulkopuoliset tappiot tarkoittavat, että riskiä pitää kaventaa.",
  "advice.detach_outcome_from_ego.title": "Irrota PnL egosta",
  "advice.detach_outcome_from_ego.body": "Kysy läpikäynnissä ensin: tapahtuiko tämä tappio suunnitelman mukaan? Jos kyllä, se on kulu. Jos ei, se on kurinalaisuusongelma.",
  "advice.large_tail_losses.title": "Pienennä suurimmat tappiot ensin",
  "advice.large_tail_losses.body": "{count} tappiota ylitti {threshold}. Nopein tapa parantaa PF:ää ei yleensä ole voittoprosentin nostaminen, vaan koko viikon rikkovien häntätappioiden leikkaaminen.",
  "advice.asset_group_relative_edge.title": "{stronger} näyttää suhteellista etua",
  "advice.asset_group_relative_edge.body": "Optioiden PF on {optionProfitFactor}; osakkeiden PF on {stockProfitFactor}. Kohdista pääoma ja huomio sinne, missä PF on vakaampi, ja tarkista oliko heikompi kori vain satunnaista testausta tai tunnepohjaista kaupankäyntiä.",
  "advice.option_sample_dominant.title": "Nykyinen otos painottuu optioihin",
  "advice.option_sample_dominant.body": "Optioiden PF on {optionProfitFactor} ja voittoprosentti {optionWinRate}. Käy erääntyminen, toteutus/assignointi, viimeisen session päätökset ja IV-muutokset erikseen läpi.",
  "advice.stock_sample_dominant.title": "Nykyinen otos painottuu osakkeisiin",
  "advice.stock_sample_dominant.body": "Osakkeiden PF on {stockProfitFactor} ja voittoprosentti {stockWinRate}. Tarkista pitoaika, stopin johdonmukaisuus ja perässä juoksevat sisääntulot ennen kuin sekoitat tulokset optioihin.",
  "advice.weak_option_underlying_days.title": "Heikot optioiden symbolipäivät kannattaa käydä erikseen läpi",
  "advice.weak_option_underlying_days.body": "{rows}. Nämä yhdistelmät ovat lähempänä todellista päätöstilannetta kuin yhteenvetotaulukko. Tarkista ensin suunta, sisääntulohetki ja erääntymisen läheisyys.",
  "advice.clean_sample.title": "Pidä otos puhtaana",
  "advice.clean_sample.body": "Mikään yksittäinen omaisuuslaji ei selvästi vedä tulosta alas. Kerää lisää puhtaita suljettuja kauppoja ja tarkista sitten syklisyys, symbolikeskittymä ja setupien vakaus.",
} satisfies Translations;
